export default __webpack_public_path__ + "src/assets/icn-warning.13fbf3efac136ed7b072e906f79f5121.svg";